export {
	createCustomTip,
	CUSTOM_TIP_MAX_AMOUNT,
	CUSTOM_TIP_MAX_DECIMAL_PLACES,
	normalizeCustomTipInput,
} from './rules';
export { TipCalculationFactory } from './tip-calculation-factory.service';
export {
	TipCalculationProcessor,
	tipCalculationProcessor,
} from './tip-calculation-processor.service';
export { CustomTipInput, TipCalculationStrategy } from './interfaces';
export { FixedTipStrategy, PercentageTipStrategy } from './strategies';
